import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import Swal, { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class SwalService {
  ready$ = new BehaviorSubject<boolean>(true);
  private translateService = inject(TranslateService);

  private _swalData = {
    icon: 'success' as any,
    title: '',
    text: '',
    html: '',
    showCancelButton: false,
    cancelButtonText: '',
    confirmButtonText: '',
    customClass: undefined as any,
  };

  get swal() {
    const self = this;

    return {
      get icon() {
        return self._swalData.icon;
      },
      set icon(value: any) {
        self._swalData.icon = value;
      },
      get title() {
        return self._swalData.title;
      },
      set title(value: string) {
        self._swalData.title = value;
      },
      get text() {
        return self._swalData.text;
      },
      set text(value: string) {
        self._swalData.text = value;
      },
      get html() {
        return self._swalData.html;
      },
      set html(value: string) {
        self._swalData.html = value;
      },
      get showCancelButton() {
        return self._swalData.showCancelButton;
      },
      set showCancelButton(value: boolean) {
        self._swalData.showCancelButton = value;
      },
      get cancelButtonText() {
        return self._swalData.cancelButtonText;
      },
      set cancelButtonText(value: string) {
        self._swalData.cancelButtonText = value;
      },
      get confirmButtonText() {
        return self._swalData.confirmButtonText;
      },
      set confirmButtonText(value: string) {
        self._swalData.confirmButtonText = value;
      },
      get customClass() {
        return self._swalData.customClass;
      },
      set customClass(value: any) {
        self._swalData.customClass = value;
      },
      fire: (options?: SweetAlertOptions) => {
        const defaultCustomClass = {
          confirmButton: 'button button--filled button--shadow',
          cancelButton: 'button button--outlined',
        };

        const finalOptions: SweetAlertOptions = {
          icon: self._swalData.icon,
          title: self._swalData.title,
          text: self._swalData.text,
          html: self._swalData.html || undefined,
          showCancelButton: self._swalData.showCancelButton,
          cancelButtonText: self._swalData.cancelButtonText || undefined,
          confirmButtonText:
            self._swalData.confirmButtonText ||
            this.translateService.instant('OK'),
          customClass: {
            ...defaultCustomClass,
            ...(self._swalData.customClass || {}),
            ...(options?.customClass || {}),
          },
          ...options,
        };

        self._swalData = {
          icon: 'success' as any,
          title: '',
          text: '',
          html: '',
          showCancelButton: false,
          cancelButtonText: '',
          confirmButtonText: '',
          customClass: undefined as any,
        };

        return Swal.fire(finalOptions);
      },
    };
  }

  fire(options: SweetAlertOptions): Promise<SweetAlertResult> {
    return Swal.fire(options);
  }
}
